export default __webpack_public_path__ + "locales/tr/Files.json?hash=91163d4e9bfc3ef579cb9b52669687fd";